/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { useForm } from "../hooks/useForm";
import { verificationCode } from "../api/api";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactComponent as Logo } from "../images/logoBlue.svg";
import { Scaffold } from "../Scaffold";
import LoadingSpinner from "../LoadingSpinner";
import { State } from "../redux/types";
import { setEnterCode } from "../redux/actions";

export const EnterCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const email = useSelector((state: State) => state.forgotPassword);
  const [enterCodeValue, setEnterCodeValue] = useState<string>("");

  const onEnterCodeChange = (e: any) => setEnterCodeValue(e.target.value);
  const [isLoading, setIsLoading] = useState(false);

  const initial = {
    username: "",
    password: "",
  };
  const validate = () => "";

  const submit = async () => {
    if (!enterCodeValue) {
      setError("Please enter verification code");
      return;
    }
    setIsLoading(true);
    try {
      const body = {
        medleyUserEmail: email?.medleyUserEmail,
        confirmationCode: enterCodeValue,
      };
      const response = await verificationCode(body);
      const dataObject = response as any;
      console.log(dataObject);
      dispatch(setEnterCode(dataObject));
      navigate("/resetpassword");
    } catch (e) {
      const err = e as AxiosError;
      console.log(err);
      if (err.response?.status === 403) {
        setError("Please Connect To VPN/Or Contact Support ");
      } else if (err.response?.status === 400) {
        setError("Please Contact Support to Reset Password");
      } else if (err.response?.status === 401) {
        setError("Unable to Login Please Check Credentials");
      } else if (
        err.response?.status === 429 ||
        err.response?.status === 404 ||
        err.response?.status === 500
      ) {
        setError("An Error Occurred Please Contact Support");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const { onSubmit } = useForm({
    initial,
    validate,
    submit,
  });
  return (
    <Scaffold center>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Card
          sx={{ width: 400, boxShadow: "0 0 5px 2px #C5C6D0", padding: "30px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Logo
              style={{
                marginTop: "-30px",
                marginLeft: "40px",
              }}
            />
            <Typography
              variant="h5"
              textAlign="left"
            >
              Enter Code
            </Typography>
          </Box>
          <CardContent>
            <Box>
              <Stack spacing={2}>
                <form onSubmit={onSubmit}>
                  <Stack spacing={2}>
                    <TextField
                      onChange={onEnterCodeChange}
                      size="small"
                      id="outlined-basic"
                      variant="outlined"
                      type={"email"}
                      value={enterCodeValue}
                      label="Code"
                      onBlur={validate}
                    />

                    <Button
                      type="submit"
                      variant="contained"
                      onClick={onSubmit}
                      color="primary"
                      size="medium"
                      disabled={
                        Boolean(enterCodeValue === "" || validate() !== "")
                      }
                    >
                      Enter Code
                    </Button>
                  </Stack>
                  {error && (
                    <Typography
                      marginTop="10px"
                      marginBottom="0px"
                      variant="body1"
                      color="red"
                      fontWeight="500"
                    >
                      {error}
                    </Typography>
                  )}
                </form>
              </Stack>
            </Box>
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate("/")}
            >
              Back To Login
            </Button>
          </CardContent>
        </Card>
      )}
    </Scaffold>
  );
};
